import React from 'react';
import {Link} from 'react-router-dom';
import RecoveryTreeLogo from './RecoveryTreeLogo';
import site from '../../data/site';

/*
 * Shared chrome for the Privacy Policy and Terms and Conditions pages:
 * sticky nav with a "Back to site" link, dark legal hero, light body, slim footer bar.
 */
const LegalLayout = ({title, children}) => (
    <div className="sw-redesign sw-legal">
        <nav className="sw-nav sw-legal__nav">
            <Link to="/" className="sw-nav__brand">
                <RecoveryTreeLogo/>
                <div>
                    <p className="sw-nav__brand-name">STRATEGIC WELLNESS</p>
                    <p className="sw-nav__brand-sub">ADVOCATES LLC</p>
                </div>
            </Link>
            <Link to="/" className="sw-legal__back">← Back to site</Link>
        </nav>

        <div className="sw-legal__hero">
            <div className="sw-legal__grid-bg"/>
            <div className="sw-legal__hero-inner">
                <p className="sw-eyebrow sw-eyebrow--cyan">Legal</p>
                <h1 className="sw-heading sw-legal__title">{title}</h1>
                <p className="sw-legal__date">Effective date: {site.legal.effectiveDate}</p>
            </div>
        </div>

        <div className="sw-legal__body">
            <div className="sw-legal__body-inner">
                {children}
            </div>
        </div>

        <footer className="sw-legal__footer">
            <div className="sw-legal__footer-inner">
                <p>© {new Date().getFullYear()} {site.name}. All Rights Reserved.</p>
                <div className="sw-legal__footer-links">
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </div>
            </div>
        </footer>
    </div>
);

/* Section heading + body used by both legal pages */
export const LegalSection = ({title, children}) => (
    <div className="sw-legal__section">
        <h2 className="sw-legal__section-title">{title}</h2>
        {children}
    </div>
);

/* Contact card shown at the bottom of each legal page */
export const LegalContactCard = () => (
    <address className="sw-legal__address">
        <strong>{site.name}</strong><br/>
        {site.address.lines[0]}, {site.address.lines[1]}<br/>
        {site.address.lines[2]}<br/>
        {site.phones.map((phone, i) => (
            <React.Fragment key={phone.href}>
                {i > 0 && ' · '}
                <a href={phone.href}>{phone.label}</a>
            </React.Fragment>
        ))}<br/>
        FAX: {site.fax}
    </address>
);

export default LegalLayout;
